import 'angular-ui-carousel';
import 'angular-ui-grid';
import 'angular-google-chart';
import * as angular from "angular";
import 'angular-super-gallery/dist/angular-super-gallery.css';
import 'angular-super-gallery';
import 'angular-animate';
import 'angular-touch';
import 'screenfull';
import {HomePageComponent} from "./components/homePage/HomePageComponent";
import {MyDatasetPageComponent} from "./components/dashboardPage/MyDatasetPageComponent";
import {DashboardPageComponent} from "./components/dashboardPage/DashboardPageComponent";
import {DatasetModalComponent} from "./components/dashboardPage/DatasetModalComponent";
import {DatasetPageComponent} from "./components/datasetPage/DatasetPageComponent";
import {DataviewPageComponent} from "./components/datasetPage/DataviewPageComponent";
import {DataviewPivotPageComponent} from "./components/datasetPage/DataviewPivotPageComponent";
import {SearchPageComponent} from "./components/searchPage/SearchPageComponent";
import {ShowMoreModalComponent} from "./components/searchPage/ShowMoreModalComponent";
import {FeedbackPageComponent} from "./components/feedbackPage/FeedbackPageComponent";
import {AboutPageComponent} from "./components/aboutPage/AboutPageComponent";
import {TermPageComponent} from "./components/termPage/TermPageComponent";
import {PrivacyPageComponent} from "./components/privacyPage/PrivacyPageComponent";
import {DataPolicyPageComponent} from "./components/dataPolicyPage/DataPolicyPageComponent";
import {DataChampionPageComponent} from "./components/dataChampionPage/DataChampionPageComponent";
import {DisclaimerPageComponent} from "./components/disclaimerPage/DisclaimerPageComponent";
import {DataFocusModalComponent} from "./components/datasetPage/DataFocusModalComponent";
import {DatasetService} from "./core/services/DatasetService";
import {InfiniteScroll} from "./core/directives/InfiniteScroll";
import {NgEnter} from "./core/directives/ngEnter";
import FirstCap from "./core/filters/firstCap";
import Unique from "./core/filters/unique";

import {config as routesConfig} from "./configs/routes";

const module = angular.module("app.home", ['ui.carousel', 'ui.grid', 'ui.grid.pinning', 'ui.grid.infiniteScroll', 'ui.grid.cellNav', 'ui.grid.autoResize','ui.grid.resizeColumns', 'googlechart', 'angularSuperGallery'])
    .component("homePage", new HomePageComponent())
    .component("datasetModal", new DatasetModalComponent())
    .component("datasetPage", new DatasetPageComponent())
    .component("dataviewPage", new DataviewPageComponent())
    // .component("dataviewPage", new DataviewPivotPageComponent())
    .component("searchPage", new SearchPageComponent())
    .component("showMoreModal", new ShowMoreModalComponent())
    .component("feedbackPage", new FeedbackPageComponent())
    .component("aboutPage", new AboutPageComponent())
    .component("termPage", new TermPageComponent())
    .component("privacyPage", new PrivacyPageComponent())
    .component("policyPage", new DataPolicyPageComponent())
    .component("championPage", new DataChampionPageComponent())
    .component("disclaimerPage", new DisclaimerPageComponent())
    .component("rowFocusModal", new DataFocusModalComponent())
    .service("DatasetService", DatasetService)
    .directive("infiniteScroll", () => new InfiniteScroll())
    .directive("ngEnter", () => new NgEnter())
    .filter("firstCap", () => FirstCap)
    .filter("unique", () => Unique)
    .config(routesConfig)
    .run(['Carousel', (Carousel) => {
      Carousel.setOptions({});
    }]);

if (TARGET !== 'public') {
  module
  .component("myDatasetPage", new MyDatasetPageComponent())
  .component("dashboardPage", new DashboardPageComponent())
}
